export default function JobSuggestions({ suggestions = [], onSelect }) {
  return (
    <div className="flex justify-center mt-3">
      <div className="flex flex-col gap-2">
        {suggestions.map((suggestion) => (
          <button
            key={suggestion}
            onClick={() => onSelect(suggestion)}
            className="px-5 py-2.5 bg-gray-800 border border-gray-700 rounded-lg text-sm text-gray-400 hover:border-gray-500 hover:text-gray-200 transition text-left w-full"
          >
            {suggestion}
          </button>
        ))}
      </div>
    </div>
  );
}
